<template>
  <div>
    <field-label :field="field"></field-label>
    <prism-editor
      class="css-editor"
      :value="value"
      :highlight="highlighter"
      line-numbers
      :tab-size="4"
      @input="input"
    ></prism-editor>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-css'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  name: 'CssEditorField',
  props: ['value', 'field'],
  components: {
    FieldLabel,
    PrismEditor
  },
  computed: {
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.css) // languages.<insert language> to return html with markup
    },
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>

<style>
/* required class */
.css-editor {
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: inherit;
  font-size: 16px;
  line-height: 1.5;
  padding: 10px 5px;
  min-height: 300px;
  max-height: 500px;
  border-radius: 4px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>
